import { gql } from '@apollo/client';

export const SoftwareEscrowDashboardFragment = gql`
  fragment SoftwareEscrowDashboardFragment on SoftwareEscrow {
    id
    changesRequested
    agreement {
      id
      agreementForm
      approved
    }
    escrowInvitation {
      id
      status
      companyName
      policy {
        accept
      }
    }
    escrowTermination {
      status
      terminateAt
    }
    status
    beneficiary {
      id
      companyName
      companyWebsite
    }
    depositor {
      id
      companyName
      companyWebsite
    }
    policy {
      remove
    }
    createdAt
    adminReviewAt
    onboardingAt
    signedAt
    activatedAt
    certificationVerified
    certificationCertified
    lastDeposit
    userUpdatedAt
    pendingActivation
  }
`;
